import { PersonalInformation } from './personal-information.page';

export { PersonalInformation };
